import { values } from "lodash";
import GrComponentFactory from "../gr_component_factory";
import ProgressBar from "../progress_bar";
import GrPropTypes from "../shared/gr_prop_types";
import { PositionTypes,
  currentPositionLabel,
  isDisplayableAsPercent } from "../../modules/reading_session_helper";

export default GrComponentFactory.createClass({
  displayName: "ReadingProgressBar",

  propTypes: {
    positionType: React.PropTypes.oneOf(values(PositionTypes)),
    currentPosition: GrPropTypes.naturalNumber.isRequired,
    finalPosition: GrPropTypes.naturalNumber,
  },

  render() {
    const labelText = currentPositionLabel(this.props);
    if (isDisplayableAsPercent(this.props)) {
      return (
        <ProgressBar
          aria-label={`Reading progress: ${labelText}`}
          bemModifiers="thick"
          value={this.props.currentPosition}
          max={this.props.finalPosition}
          width={70}>
          <div className="u-defaultType u-inlineBlock u-marginLeftXSmall u-verticalAlignMiddle">
            {labelText}
          </div>
        </ProgressBar>
      );
    } else {
      return (
        <small className="u-displayBlock u-marginTopTiny">
          {labelText}
        </small>
      );
    }
  },
});
